import React, { useMemo, useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import type { SickdayChartItem } from '../../graphql/types/admin_dashboard'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const SickdayGraph = ({
  sickdayChart,
}: {
  sickdayChart: SickdayChartItem[]
}) => {
  const chartRef = useRef(null)
  const data = useMemo(
    () => ({
      labels: sickdayChart.map((u) => u.name),
      datasets: [
        {
          label: 'Krankheitstage',
          data: sickdayChart.map((u) => u.sickdays),
          backgroundColor: '#D64545',
        },
      ],
    }),
    [sickdayChart],
  )

  const options = {
    responsive: true, 
    plugins: {
      title: {
        display: true,
        text: 'Krankheitstage pro Mitarbeiter',
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: false, 
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Tage',
        },
        ticks: {
          stepSize: 1,
        },
      },
    },
  }

  return (
    <div className="flex flex-col py-3 pr-3">
        <Bar ref={chartRef} options={options} data={data} height={80} />
    </div>
  )
}